import styled from 'styled-components';
import { breakpoints } from 'design-system/src/tokens/breakpoints';

const Container = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;

  @media (min-width: ${breakpoints.smallDesktopMin}) {
    max-width: var(--main-content-width);
    margin: 0 auto;
  }
`;

const StyledIframe = styled.iframe`
  padding: 16px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: none;

  @media (min-width: ${breakpoints.smallDesktopMin}) {
    padding: 24px;
  }
`;

/**
 * This attempts to fill the parent container as much as possible
 */
export function IframeContainer({ embeddedUrl }: { embeddedUrl: string }) {
  return (
    <Container>
      <StyledIframe
        src={embeddedUrl}
        // ignore this element in chromatic because the async loading of the contents makes the test flaky
        data-chromatic="ignore"
      />
    </Container>
  );
}
